import React from "react";
import { Accordion, Container } from "react-bootstrap";

const FaqSection = () => {
  return (
    <section className="faq-section">
      <Container>
        <div className="faq-content">
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>How can I place an order?</Accordion.Header>
              <Accordion.Body>
                You can browse products on our website, add them to your cart,
                and complete the checkout process by providing your contact
                details and preferred payment method.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                What payment methods do you accept?
              </Accordion.Header>
              <Accordion.Body>
                We accept major credit/debit cards, UPI, net banking, and
                digital wallet payments. All transactions are 100% secure.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                Can I modify or cancel my order after placing it?
              </Accordion.Header>
              <Accordion.Body>
                Modifications or cancellations are only possible before the
                order is shipped. Please contact our support team as soon as
                possible.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                How long will it take to receive my order?
              </Accordion.Header>
              <Accordion.Body>
                Delivery times may vary depending on your location. Typically,
                orders are delivered within 3–7 business days.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>How can I track my order?</Accordion.Header>
              <Accordion.Body>
                Once shipped, you will receive a tracking link via email/SMS so
                you can follow your order in real time.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>
                Do you offer international shipping?
              </Accordion.Header>
              <Accordion.Body>
                Currently, we ship only within [your shipping region]. We are
                working to add more locations soon.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="6">
              <Accordion.Header>What is your return policy?</Accordion.Header>
              <Accordion.Body>
                We offer a hassle-free 7-day return for damaged, defective, or
                incorrect products. Items must be unused and in original
                packaging.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="7">
              <Accordion.Header>
                How do I request a return or replacement?
              </Accordion.Header>
              <Accordion.Body>
                Contact our support team with your order details and issue. We
                will guide you through the return process.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="8">
              <Accordion.Header>When will I get my refund?</Accordion.Header>
              <Accordion.Body>
                Refunds are issued to the original payment method within 5–10
                business days after the returned item is inspected.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </Container>
    </section>
  );
};
export default FaqSection;
